<template>
  <div>
    <h2>Sua vistoria de assistência técnica foi agendada com sucesso.</h2>
    <AssistanceSummary
      :items="reasons"
      :accompanied="accompanied"
      :date="date"
      :address="address"
      :ticketCreationNotice="ticketCreationNotice"
    />
  </div>
</template>

<script>
import AssistanceSummary from "@/components/AssistanceSummary";
import moment from "moment-timezone";
import bus from "@/utils/bus";
import { UNIT, CONFIG } from "@/utils/constants";

export default {
  props: {
    concludedDate: Object,
    reasonTicketInfo: Array,
  },
  components: {
    AssistanceSummary,
  },
  data() {
    return {
      reasons: [],
      accompanied: undefined,
      date: undefined,
      address: undefined,
      ticketCreationNotice: undefined,
    };
  },
  methods: {
    parseReasons(reasons) {
      reasons.map((reason) => {
        reason.subReasons.map((subReason) => {
          this.reasons.push({
            reason: reason.name,
            subReason: subReason.name,
          });
        });
      });
    },
    parseTicketResons(workOrders) {
      this.reasons = workOrders.map((item) => {
        return {
          reason: item.nameReason,
          subReason: item.nameSubReason,
        };
      });
    },
    formatDate(date) {
      this.date = this.formatLongDateTime(date);
    },
    mountAccompanied(schedule) {
      if (schedule.accompanied) {
        this.accompanied = schedule.accompanied;
      }
    },
    mountAddress() {
      this.address = this.$store.getters[UNIT.GET_SELECTED_PRODUCT].address;
      this.address.product = this.selectedUnit.product.title;
      this.address.block = this.selectedUnit.block.title;
    },
    async getReasonTicket() {
      const kitfixUrl = this.$store.getters[CONFIG.GET_KITFIX_URL];
      let url = `${kitfixUrl}/api/workOrder/getScheduledWorkOrdersInfoBySku`;
      const params = {
        sku: this.selectedUnit.sku
      }
      return await this.requestService(url, 'GET', {params});
    },
    mountTicketInfo(response) {
      if (response) {
        let ticketId = this.reasonTicketInfo[0].ticketId;
        let ticket = response.find((item) => item.idTicket == ticketId);
        this.mountAccompanied(this.reasonTicketInfo[0]);
        this.formatDate(ticket.scheduleDate);
        this.parseTicketResons(ticket.workOrders);
      } else {
        bus.$emit("snackbar:open", {
          text: this.$t("responses.error"),
          color: enums.snackbarColors.error,
        });
      }
    },
    mountTicketCreationNotice() {
      const config = this.$store.getters[CONFIG.GET];

      if (config && config.texts && config.texts.ticketCreationNotice) {
        this.ticketCreationNotice = `\n${config.texts.ticketCreationNotice}\n`;
      }
    },
    async loadData() {
      if (this.reasonTicketInfo && !!this.reasonTicketInfo.length) {
        const response = await this.getReasonTicket();
        this.mountTicketInfo(response);
      } else {
        this.parseReasons(this.concludedDate.reasons);
        this.mountAccompanied({
          accompanied: {
            name: this.concludedDate.companionName,
            document: this.concludedDate.companionDocument,
          },
        });
        this.formatDate(this.concludedDate.scheduleDate);
      }
    },
  },
  created() {
    this.loadData();
    this.mountAddress();
    this.mountTicketCreationNotice();
  },
};
</script>

<style lang="scss" scoped>
h2 {
  display: inline-block;
  margin: 20px 0;
  font-size: 14px;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/support/ticket/technicalAssistance/ConcludedStep.vue